import React, {PropTypes} from 'react';
import RetinaImage from 'react-retina-image';

export default function FoundationOverviewVisual({imageName}) {
  return (
    <div className="foundation-overview-visual">
      <RetinaImage src={[require(`../images/${imageName || 'img-nopic'}.png`), require(`../images/${imageName || 'img-nopic'}@2x.png`)]} />
    </div>
  );
}

FoundationOverviewVisual.propTypes = {
  imageName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/features/dashboard/components/FoundationOverviewVisual.js